import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace ABIUrbanRatRace {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: true,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.tubes,
          elementType: "level",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_element_level.rookie,
              id: Constants.dog_class_element_level.rookie,
            },
            {
              value: Constants.dog_class_element_level.clever,
              id: Constants.dog_class_element_level.clever,
            },
            {
              value: Constants.dog_class_element_level.adventurer,
              id: Constants.dog_class_element_level.adventurer,
            },
            {
              value: Constants.dog_class_element_level.explorer,
              id: Constants.dog_class_element_level.explorer,
            },
            {
              value: Constants.dog_class_element_level.detective,
              id: Constants.dog_class_element_level.detective,
            },
            {
              value: Constants.dog_class_element_level.investigator,
              id: Constants.dog_class_element_level.investigator,
            },
          ],
        },
        {
          type: "dropdown",
          defaultValue: "None",
          label: "Section",
          showElement: Constants.dog_class_element.tubes,
          elementType: "section",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_section.on_leash,
              id: Constants.dog_class_section.on_leash,
            },
            {
              value: Constants.dog_class_section.unleashed,
              id: Constants.dog_class_section.unleashed,
            },
          ],
        },
      ],
    },
    {
      allowDuplicates: true,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.unobstructed,
          elementType: "level",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_element_level.rookie,
              id: Constants.dog_class_element_level.rookie,
            },
            {
              value: Constants.dog_class_element_level.clever,
              id: Constants.dog_class_element_level.clever,
            },
            {
              value: Constants.dog_class_element_level.adventurer,
              id: Constants.dog_class_element_level.adventurer,
            },
            {
              value: Constants.dog_class_element_level.explorer,
              id: Constants.dog_class_element_level.explorer,
            },
            {
              value: Constants.dog_class_element_level.detective,
              id: Constants.dog_class_element_level.detective,
            },
            {
              value: Constants.dog_class_element_level.investigator,
              id: Constants.dog_class_element_level.investigator,
            },
          ],
        },
        {
          type: "dropdown",
          defaultValue: "None",
          label: "Section",
          showElement: Constants.dog_class_element.unobstructed,
          elementType: "section",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_section.on_leash,
              id: Constants.dog_class_section.on_leash,
            },
            {
              value: Constants.dog_class_section.unleashed,
              id: Constants.dog_class_section.unleashed,
            },
          ],
        },
      ],
    },
    {
      allowDuplicates: true,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.obstructed,
          elementType: "level",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_element_level.rookie,
              id: Constants.dog_class_element_level.rookie,
            },
            {
              value: Constants.dog_class_element_level.clever,
              id: Constants.dog_class_element_level.clever,
            },
            {
              value: Constants.dog_class_element_level.adventurer,
              id: Constants.dog_class_element_level.adventurer,
            },
            {
              value: Constants.dog_class_element_level.explorer,
              id: Constants.dog_class_element_level.explorer,
            },
            {
              value: Constants.dog_class_element_level.detective,
              id: Constants.dog_class_element_level.detective,
            },
            {
              value: Constants.dog_class_element_level.investigator,
              id: Constants.dog_class_element_level.investigator,
            },
          ],
        },
        {
          type: "dropdown",
          defaultValue: "None",
          label: "Section",
          showElement: Constants.dog_class_element.obstructed,
          elementType: "section",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_section.on_leash,
              id: Constants.dog_class_section.on_leash,
            },
            {
              value: Constants.dog_class_section.unleashed,
              id: Constants.dog_class_section.unleashed,
            },
          ],
        },
      ],
    },
    {
      allowDuplicates: true,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.obstructed_2,
          elementType: "level",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_element_level.rookie,
              id: Constants.dog_class_element_level.rookie,
            },
            {
              value: Constants.dog_class_element_level.clever,
              id: Constants.dog_class_element_level.clever,
            },
            {
              value: Constants.dog_class_element_level.adventurer,
              id: Constants.dog_class_element_level.adventurer,
            },
            {
              value: Constants.dog_class_element_level.explorer,
              id: Constants.dog_class_element_level.explorer,
            },
            {
              value: Constants.dog_class_element_level.detective,
              id: Constants.dog_class_element_level.detective,
            },
            {
              value: Constants.dog_class_element_level.investigator,
              id: Constants.dog_class_element_level.investigator,
            },
          ],
        },
        {
          type: "dropdown",
          defaultValue: "None",
          label: "Section",
          showElement: Constants.dog_class_element.obstructed_2,
          elementType: "section",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_section.on_leash,
              id: Constants.dog_class_section.on_leash,
            },
            {
              value: Constants.dog_class_section.unleashed,
              id: Constants.dog_class_section.unleashed,
            },
          ],
        },
      ],
    },

    // Games - now as individual checkboxes without sections
    {
      inputs: [{
        type: "checkbox",
        multiSelect: true,
        label: Constants.dog_class_element.games,
        options: [
          { value: Constants.dog_class_element_level.fantastic_five, id: Constants.dog_class_element_level.fantastic_five },
          { value: Constants.dog_class_element_level.tempting_ten, id: Constants.dog_class_element_level.tempting_ten },
          { value: Constants.dog_class_element_level.junkyard, id: Constants.dog_class_element_level.junkyard },
          { value: Constants.dog_class_element_level.junkyard_ex, id: Constants.dog_class_element_level.junkyard_ex },
          { value: Constants.dog_class_element_level.tag_team, id: Constants.dog_class_element_level.tag_team },
        ]
      }]
    },

  ];
}
